import { z } from 'zod';

/**
 * Who opened a direct-payment order (F3).
 *
 * `staff` is the P23a3 door: an operator keys the order in and attaches the
 * receipt the member sent them. `member` is the phone's own door: the member
 * transfers, uploads the receipt, and the order lands `awaiting_confirmation`
 * with the receipt already bound — the same row and the same state machine
 * from there on. The origin is what the staff queue sorts its work by, and what
 * decides that a receipt is the member's (never detached, only decided on).
 */
export const DIRECT_PAYMENT_ORDER_ORIGINS = ['staff', 'member'] as const;

export const DirectPaymentOrderOriginSchema = z.enum(DIRECT_PAYMENT_ORDER_ORIGINS);

export type DirectPaymentOrderOrigin = (typeof DIRECT_PAYMENT_ORDER_ORIGINS)[number];

const ORIGIN_SET: ReadonlySet<string> = new Set<string>(DIRECT_PAYMENT_ORDER_ORIGINS);

export function isDirectPaymentOrderOrigin(value: string): value is DirectPaymentOrderOrigin {
  return ORIGIN_SET.has(value);
}
